import "./order-card-processing.scss";

import { useState } from "react";

import { OrderTabsLoadingOverlay } from "../../order-tabs-loading-overlay";

export const OrderInProcessing = () => {
	const [clicked, setClicked] = useState(false);

	return (
		<div
			className="order-in-processing-wrapper"
			onClick={() => {
				setClicked(true);
			}}
		>
			{clicked && (
				<div className="order-in-processing-message">
					<OrderTabsLoadingOverlay verticalCenter label="Please wait..." />
				</div>
			)}
		</div>
	);
};
